import {Injectable} from '@angular/core';
import {Headers, Http} from '@angular/http';

import 'rxjs/add/operator/toPromise';

@Injectable()
export class WharehousesService {
    private headers = new Headers({'Content-Type': 'application/json'});

    private api_url_create_warehouse = './api/server.php?cmd=CREATE_STORAGE';
    private api_url_get_warehouses = './api/switch_site/server.php?cmd=GET_WAREHOUSE';
    private api_url_search_warehoouse = './api/switch_site/server.php?cmd=SEARCH_WAREHOUSE';
    private api_url_get_current_warehouse = './api/server.php?cmd=GET_CURRENT_WAREHOUSE';

    constructor(private http: Http) {}

    CreateWharehouse(storage_name: string): Promise<Object> {

        return this.http.get(this.api_url_create_warehouse + '&storage_name=' + storage_name)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);

    }

    GetWarehouses(): Promise<Object> {
        return this.http.get(this.api_url_get_warehouses)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    WarehousesSearch(warehouse_name: string): Promise<Object> {
        return this.http.get(this.api_url_search_warehoouse + '&word=' + warehouse_name)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    getCurrentWarehouse(): Promise<string> {
        return this.http.get(this.api_url_get_current_warehouse)
            .toPromise()
            .then(response => response.json() as string)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }

}


// WEBPACK FOOTER //
// ./src/app/warehouses.service.ts